/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import Img from 'gatsby-image';
import PropTypes from 'prop-types';
import withIntegrationCardContext from 'hoc/withIntegrationCardContext';
import Slider from 'react-slick';

const Shopify = ({ sliderSettings }) => {
  const { img1 } = useStaticQuery(graphql`
    query {
      img1: file(relativePath: { eq: "help/shopify/shopify_marketplace.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `);
  const photos = [
    {
      img: img1.childImageSharp.fluid,
      alt: 'Shopify Integration',
      title: 'Integrate Shopify with LiveSession',
    },
  ];
  return (
    <>
      <Slider {...sliderSettings(photos)} className="without-dots">
        <div>
          <Img fluid={photos[0].img} alt={photos[0].alt} title={photos[0].title} />
        </div>
      </Slider>
      <div className="section">
        <h2>Overview</h2>
        <p>
          Shopify is one of the biggest e-commerce solutions in the world. You can add a LiveSession
          tracking script to your Shopify-based online store and see how the users behave on the
          website.
        </p>
      </div>
      <div className="section">
        <h2>Benefits</h2>
        <ul className="checkmarks">
          <li>Watch how visitors interact with your website</li>
          <li>Discover areas for improvement</li>
          <li>Boost your e-commerce conversions</li>
        </ul>
      </div>
      <h2>How to install</h2>
      <p>
        Just one-click steps. See a detailed tutorial in our{' '}
        <a href="/help/shopify-integration/">help center</a>.
      </p>
    </>
  );
};

export default withIntegrationCardContext(Shopify);

Shopify.propTypes = {
  sliderSettings: PropTypes.func.isRequired,
};
